import { render } from "./FormEmailSetting.vue?vue&type=template&id=b3b6a1ee&scoped=true"
import script from "./FormEmailSetting.vue?vue&type=script&lang=js"
export * from "./FormEmailSetting.vue?vue&type=script&lang=js"

import "./FormEmailSetting.vue?vue&type=style&index=0&id=b3b6a1ee&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b3b6a1ee"

export default script